import baseData from './baseData'; // 基础数据
import url from './url'; // ajax请求URL
import regExp from './regExp'; // 正则校验

export default {
  baseData,
  url,
  regExp,
}
